module.exports = __webpack_public_path__ + "img/icon_machine_empty.b01350bc.svg";